module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"aboutCompany":"О компании"}}')
  delete Component.options._Ctor
}
